import React, { useState } from "react";
import PropTypes from "prop-types";
import StarRatings from "react-star-ratings";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./BookALessonCardWithGallery.module.css";
import {
  coachDemoImg,
  DisableHeartIcon,
  DummyVideo,
  GalleryImg1,
  GalleryImg2,
  GalleryImg3,
  HeartIcon,
  messageIcon,
  messageIconBlack,
  VideoPlayIcon,
} from "../../constant/imagePath";
import { Row, Col } from "react-bootstrap";
import { Button } from "../Button/Button";
import ReactPlayer from "react-player/lazy";

export const BookALessonCardWithGallery = ({
  data,
  galleryData,
  disabledBtns,
  onClickbtn1,
  onClickbtn2,
  onClickbtn3,
}) => {
  const [playing, setPlaying] = useState(false);
  return (
    <div>
      <Row>
        <Col md={12}>
          <div className={classes.purchasedLessonCard}>
            <div className="d-flex">
              <div className={`${[classes.profile].join(" ")}`}>
                <img src={data?.userData?.photo} />
              </div>
              <div className="ms-4">
                <h5 className={classes.mainHeading}>
                  <span
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h4f26,
                    }}
                  >
                    {data?.userData?.displayName.split(" ")[0]}
                  </span>
                  <span
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h4f26,
                    }}
                  >
                    {data?.userData?.displayName.split(" ")[1]}
                  </span>
                </h5>
                <div className={` ${[classes.userDetails].join(" ")}`}>
                  <span>
                    <StarRatings
                      starRatedColor={Colors.mainShadeOfRed}
                      starEmptyColor={Colors.neutralShadesOfDimGray}
                      rating={data?.userData.rating / 5}
                      starDimension={"20px"}
                      numberOfStars={1}
                    />
                    <span
                      className={`${[classes.rating].join(" ")}`}
                      style={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.p2,
                        fontFamily: "inter-600",
                      }}
                    >
                      {data?.userData.rating?.toFixed(1)}
                    </span>
                    <a
                      className={`${[classes.reviews].join(" ")}`}
                      style={{
                        color: Colors.neutralShadesOfDimGray,
                        ...Fonts.p2,
                      }}
                    >
                      ({data?.userData?.reviews?.length} reviews)
                    </a>
                  </span>
                  <span
                    className={`${[classes.break].join(" ")}`}
                    style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                  />
                  <span
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.p2,
                      fontFamily: "inter-600",
                    }}
                  >
                    {data?.userData?.sport}
                  </span>
                  <span
                    className={`${[classes.break].join(" ")}`}
                    style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                  />

                  <span
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.p2,
                      fontFamily: "inter-600",
                    }}
                  >
                    {data?.userData?.city}
                  </span>
                </div>
              </div>
            </div>
            {/* Right Side */}
            <div className={classes.pricingAndBooking}>
              <h6
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h4f26,
                  lineHeight: "36px",
                }}
              >
                <span style={{ ...Fonts.h5, lineHeight: "36px" }}>$</span>
                {"75 "}
                <span style={{ ...Fonts.h5, lineHeight: "36px" }}>
                  / hr per person
                </span>
              </h6>
              <div>
                <Button
                  size={"Large"}
                  customStyle={{
                    marginRight: 10,
                  }}
                  onClick={onClickbtn1}
                  icon={messageIconBlack}
                  disabled={disabledBtns}
                />
                <Button
                  size={"Large"}
                  customStyle={{ marginRight: 10 }}
                  onClick={onClickbtn2}
                  icon={HeartIcon}
                  disabled={disabledBtns}
                />
                <Button
                  customStyle={{
                    width: "281px",
                    height: "56px",
                  }}
                  onClick={onClickbtn3}
                  primary={true}
                  label={"Book a lesson"}
                  disabled={disabledBtns}
                  // disabled={true}
                />
              </div>
            </div>
          </div>
        </Col>
        {/* Gallery */}
        <Col md={12}>
          <Row>
            <Col md={6}>
              <div className={classes.playerWrapper}>
                <ReactPlayer
                  className={classes.player}
                  url={galleryData?.videoURL}
                  playing={playing}
                  width="100%"
                  height="100%"
                  playIcon={messageIcon}
                  playsinline
                  controls={playing}
                  onReady={true}
                  onStart={() => setPlaying(true)}
                  onPlay={() => setPlaying(true)}
                  onPause={() => setPlaying(false)}
                />
                {playing === false && (
                  <div className={classes.overlay}>
                    <div
                      className={classes.overlayIcon}
                      onClick={() => setPlaying(true)}
                    >
                      <img src={VideoPlayIcon} />
                    </div>
                  </div>
                )}
              </div>
            </Col>
            <Col md={3}>
              <Row>
                {galleryData?.images?.slice(0, 2)?.map((image) => {
                  return (
                    <Col md={12}>
                      <div className={classes.imageCard1}>
                        <img src={image} />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col md={3}>
              {galleryData?.images?.slice(2, 3)?.map((image) => {
                return (
                  <div className={classes.imageCard2}>
                    <img src={image} />
                  </div>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

BookALessonCardWithGallery.propTypes = {
  data: PropTypes.object,
  onClickbtn1: PropTypes.func,
  onClickbtn2: PropTypes.func,
  onClickbtn3: PropTypes.func,
  disabledBtns: PropTypes.bool,
  galleryData: PropTypes.object,
};
BookALessonCardWithGallery.defaultProps = {
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      reviews: [{}, {}, {}, {}, {}, {}, {}],
      role: "coach",
      city: "New York",
    },
    price: 85,
    date: "Aug 12, 2021",
    startTime: "12:30PM",
    endTime: "2:30PM",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    status: "defualt",
  },
  onClickbtn1: () => {},
  onClickbtn2: () => {},
  onClickbtn3: () => {},
  disabledBtns: false,
  galleryData: {
    videoURL: DummyVideo,
    images: [GalleryImg1, GalleryImg1, GalleryImg1],
  },
};
